import React from 'react'
import { CenteredMessage } from './CenteredMessage'

function TranscriptLogsComponent({ transcriptData }) {
    return (
        <div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '20px'
            }}>
                <div style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#1f2937',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    Conversation Transcript
                </div>
            </div>

            <div style={{
                height: '100%',
                overflowY: 'auto',
                padding: '20px',
                backgroundColor: '#f8fafc',
                borderRadius: '12px',
                border: '1px solid #e2e8f0'
            }}>
                {transcriptData?.length > 0 && transcriptData.some(item => item.role === 'bot' || item.role === 'user') ? (
                    transcriptData
                        .filter(item => item.role === 'bot' || item.role === 'user')
                        .map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    marginBottom: '10px',
                                    padding: '12px',
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '13px',
                                        fontWeight: '700',
                                        color: item.role === 'bot' ? '#2563eb' : '#2a9d8f',
                                        marginBottom: '6px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}
                                >
                                    {item.role}
                                </div>
                                <div
                                    style={{
                                        fontSize: '14px',
                                        lineHeight: '1.6',
                                        color: '#374151',
                                        paddingLeft: '0px'
                                    }}
                                >
                                    {item.message}
                                </div>
                            </div>
                        ))
                ) : (
                    <CenteredMessage text="No transcript available" />
                )}

            </div>

        </div>
    )
}

export default TranscriptLogsComponent